import { APIMethod, fetchData } from "@client";

export async function changeProjectNameQuery(uuid, name) {
  const data = { uuid, name };
  await fetchData("/project/name ", APIMethod.POST, { data });
}
